import React from 'react'
import { connect } from 'react-redux'
import { Icon } from 'semantic-ui-react'
import ReactTable from 'react-table'

import { WorkspaceListCont, ProcurementContainer, ProcurementBody, CardButtonBody, BodyCardContent, TitleContent, ValueContent, OverviewBodyContent } from './styled'
import SearchWorkSpace from './SearchWorkspace'
import { columns } from './AttributeData'
import { MainBodyContent } from 'components'
import { fetchWorkList } from 'ducks/workList'

const Home = (props) => {
  const { workLists } = props

  const userPageSize = parseInt(localStorage.getItem('userPageSize') || '10')

  React.useEffect(() => {
    props.fetchWorkList()
  }, [])

  const searchByProcessCode = (processCode) => {
    console.log(processCode)
    props.fetchWorkList({ processCode: processCode, date: [null, null] })
  }

  return (
    <MainBodyContent headerTitle='Workspace'>
      <OverviewBodyContent>
        {workLists &&
          workLists.summary.map((item, i, array) => {
            return (
              <CardButtonBody>
                <BodyCardContent onClick={() => searchByProcessCode(item.processCode.replace(/ /g, ''))}>
                  <TitleContent>{item.processCode}</TitleContent>
                  <ValueContent>
                    <div className='ValueText'>{item.count}</div>
                  </ValueContent>
                </BodyCardContent>
              </CardButtonBody>
            )
          })
        }
      </OverviewBodyContent>
      <ProcurementContainer>
        <ProcurementBody>
          <SearchWorkSpace />
          <WorkspaceListCont>
            <ReactTable
              data={workLists ? workLists.worklistItem : []}
              columns={columns}
              defaultPageSize={userPageSize}
              noDataText='No task found'
              previousText={<Icon name='arrow alternate circle left' />}
              nextText={<Icon name='arrow alternate circle right' />}
              className='-striped -highlight'

              onPageSizeChange={(pageSize, pageIndex) => {
                localStorage.setItem('userPageSize', pageSize)
              }}

              getTdProps={(state, rowInfo, column, instance) => {
                return {
                  onClick: (e, handleOriginal) => {
                    if (rowInfo && column && column.Header !== '') {
                      if(rowInfo.original.activityName == "Contract Committee")
                      {
                        window.open(rowInfo.original.data)
                      }else
                      {
                        props.history.push(`${rowInfo.original.data}&h=true`)
                      }
                    }
                    if (handleOriginal) {
                      handleOriginal()
                    }
                  },
                }
              }}
            />
          </WorkspaceListCont>
        </ProcurementBody>
      </ProcurementContainer>
    </MainBodyContent>
  )
}

const mapStateToProps = (state) => ({
  workLists: state.workList.workLists
})

const mapDispatchToProps = {
  fetchWorkList
}

export default connect(mapStateToProps, mapDispatchToProps)(Home)
